var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2955 4.5H10.6627C11.871 4.57144 13.2002 5.06813 13.734 6.22125C14.4017 7.68994 14.0698 9.75544 12.5657 10.5936C11.1786 11.3867 9.51919 11.0739 7.99594 11.1392C7.95487 11.8896 8.16469 12.7626 7.64156 13.3971C7.43119 13.7008 6.4665 14.0625 6.4665 14.0625C6.4665 14.0625 6.37762 13.2474 6.345 11.4131C6.32419 10.9069 6.40688 10.3387 6.84169 10.0097C7.35075 9.57206 8.07244 9.70875 8.69062 9.68625C9.62437 9.6615 10.6054 9.80438 11.4919 9.44438C12.7924 8.91281 12.8396 6.74212 11.529 6.19481C10.1908 5.67619 8.71312 6.14813 7.33837 5.86125C6.714 5.68631 6.43331 5.0715 6.2955 4.5ZM3.9375 6.99188C5.07938 7.01269 6.2235 6.95194 7.36313 7.02056C8.19169 7.08413 8.73562 7.8345 8.82225 8.60175C7.6725 8.59613 6.51994 8.63831 5.36962 8.58769C4.66312 8.54663 4.14169 7.97287 3.9375 7.34006V6.99188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPura);
export default __webpack_public_path__ + "static/media/pura.5deb6bd8569908db4e2c967a95790d30.svg";
export { ForwardRef as ReactComponent };